import React from "react";
import PaginatedTable from '../components/paginatedTable'

import { GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';

const items = [
  { id: 1, keywords: 'AI', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 35,},
  { id: 2, keywords: 'AI', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 42,},
  { id: 3, keywords: 'AI, Buy now Pay Later', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 45,},
  { id: 4, keywords: 'AI, Buy now Pay Later', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 16,},
  { id: 5, keywords: 'AI, Buy now Pay Later', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 12,},
  { id: 6, keywords: 'AI, Buy now Pay Later', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 150,},
  { id: 7, keywords: 'AI, Buy now Pay Later', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 44,},
  { id: 8, keywords: 'AI, Buy now Pay Later', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 36,},
  { id: 9, keywords: 'AI', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 65,},
  { id: 10, keywords: 'AI', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 35,},
  { id: 11, keywords: 'AI', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 42,},
  { id: 12, keywords: 'AI, Buy now Pay Later', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 45,},
  { id: 13, keywords: 'AI, Buy now Pay Later', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 16,},
  { id: 14, keywords: 'AI, Buy now Pay Later', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 12,},
  { id: 15, keywords: 'AI, Buy now Pay Later', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 150,},
  { id: 16, keywords: 'AI', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 44,},
  { id: 17, keywords: 'AI', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 36,},
  { id: 18, keywords: 'AI', type: 'Completed', date: '10 Oct 2023, 10:00 a.m.', foundStartup: 65,},
];

export default function ExpoRivaCompetition() {
  const [rows, setRows] = React.useState(items);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const header = [
    { field: 'keywords', headerName: 'Keywords', width: 200 },
    { field: 'type', headerName: 'Startup Type', width: 130 },
    { field: 'date', headerName: 'Date', width: 200 },
    { field: 'foundStartup', headerName: 'Found Startup', type: 'number', width: 120 },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 100,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
  
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: 'primary.main',
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }
  
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    }
  ];

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (!!editedRow && editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  return (
    <div className="p-5 flex justify-center items-center h-full max-h-[100vh]">
      <div className="p-5 flex items-center justify-center w-full h-full max-h-full bg-[#191919] rounded-2xl">
        <div className="flex flex-col gap-5 max-w-full max-h-full w-full h-full">
          <div className="flex items-center w-full">
            <h1 className="text-6xl font-medium">Expo Riva Competition Submition</h1>
          </div>
          <PaginatedTable header={header} items={items} />
        </div>
      </div>
    </div>
  )
}